import { gql } from '@apollo/client';
export default gql`
  fragment playbook on playbooks {
    id
    playbookJson
    connectionJson
    commitMessage
    createdBy {
      name
      email
    }
    revision
    createdAt
    disabledAt
    disabledNote
    disabledBy {
      name
      email
    }
    vars
    secretsRef
    pipeline_variables {
      id
      playbookId
      name
    }
  }
`;
